import React from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {IconButton} from "@mui/material";
import {Plus} from "lucide-react";
import {useTranslation} from "react-i18next";
import Tooltip from "@mui/material/Tooltip";

function AddToCartIconBtn({vendor,classes}) {
    const { t } = useTranslation();

    return (

        <div className="addToCart">
            <IconButton  color="secondary" className="plus">
                <Plus/>
            </IconButton>
        </div>
    );
}

export default withStyles(Styles)(AddToCartIconBtn);
